module.exports = __webpack_public_path__ + "img/0Q3B3199_L_WoodMatted_MockedUp.cd93873e.jpg";